import { useState, useEffect } from "react";
import { ImSpinner6 } from "react-icons/im";
import { AiFillCloseCircle, AiFillPlusCircle } from "react-icons/ai";
import Confetti from "react-confetti";
import ShareSheet from "./shareSheet";
import { useAuth } from "../../contexts/AuthContext";
import { ethers } from "ethers";
import { randColorClass } from "../../utils/general";
import { supabase } from "../auth/supabaseClient";

async function getENS(ensDomain) {
  const provider = new ethers.providers.JsonRpcProvider(
    process.env.REACT_APP_ALCHEMY_RPC_URL
  );
  console.log("provider", provider);

  let ethAddress = await provider.resolveName(ensDomain);

  return ethAddress;
}

var ethereum_address = require("ethereum-address");
var queryString = require("querystring");

const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

const EthWarning = () => (
  <p className="text-red-500 text-xs italic mb-3">
    Please make sure this is either a valid email, ENS or Ethereum address
  </p>
);

const EthValid = () => (
  <p className="text-green-500 text-xs italic mb-3">Valid Ethereum address</p>
);

const EnsValid = () => (
  <p className="text-green-500 text-xs italic mb-3">Valid ENS domain</p>
);

const EmailValid = () => (
  <p className="text-green-500 text-xs italic mb-3">Valid email address</p>
);

function addressRenderSwitch(param) {
  switch (param) {
    case "eth":
      return <EthValid />;
    case "ens":
      return <EnsValid />;
    case "email":
      return <EmailValid />;
    case "empty":
      return null;
    default:
      return <EthWarning />;
  }
}

function RenderOptionalFormFields(props) {
  return Object.keys(props.nftFormFields).map((key) => {
    const metadataKey = props.nftFormFields[key].metadata_key;

    return (
      <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0" key={key}>
        <label
          className="inline-flex items-center uppercase tracking-wide text-purpler text-xs font-bold mb-2"
          htmlFor={key}
        >
          <AiFillCloseCircle
            onClick={() => props.handleRemoveField(key)}
            className="mr-2 opacity-50 hover:opacity-100"
          />
          <input
            name={key}
            onChange={props.handleFieldNameChange}
            value={props.nftFormFields[key].display_name}
            className="uppercase"
          />
        </label>
        <input
          className="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
          id={key}
          type={props.nftFormFields[key].type}
          placeholder={props.nftFormFields[key].placeholder}
          name={metadataKey}
          value={props.nftMetadata[metadataKey] || ""}
          onChange={props.handleFieldValueChange || null}
        />
      </div>
    );
  });
}

function TeamSelect(props) {
  const [selectedTeam, setSelectedTeam] = useState("");
  const [teams, setTeams] = useState([]);

  useEffect(() => {
    if (props.userId) {
      fetchTeams();
    }
  }, [props.userId]);

  const fetchTeams = async () => {
    const { data: teamMembershipData, teamMembershipError } = await supabase
      .from("team_membership")
      .select("*")
      .eq("user_id", props.userId)
      .in("role", ["issuer", "admin"]);

    console.log("teamMembershipData", teamMembershipData);

    if (teamMembershipError) throw teamMembershipError;

    if (teamMembershipData.length > 0) {
      const { data: teamData, teamError } = await supabase
        .from("teams")
        .select("*")
        .in(
          "id",
          teamMembershipData.map((team) => team.team_id)
        );

      if (teamError) throw teamError;

      setTeams(teamData);
      props.handleSelectTeam(teamMembershipData[0].team_id);
    }

    if (teamMembershipData.length === 1) {
      props.handleSelectTeam(teamMembershipData[0].team_id);
    }
  };

  const generateOptions = () => {
    return teams.map((team) => {
      return (
        <option key={team.id} value={team.id}>
          {team.team_name}
        </option>
      );
    });
  };

  function handleSelectChange(e) {
    setSelectedTeam(e.target.value);
    props.handleSelectTeam(e.target.value);
  }

  return (
    <div className="relative inline-block w-full text-gray-700">
      <select
        value={selectedTeam}
        onChange={handleSelectChange}
        name="team"
        className="w-full appearance-none block bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
      >
        {generateOptions()}
      </select>
      <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
        <svg className="w-4 h-4 fill-current" viewBox="0 0 20 20">
          <path
            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
            clipRule="evenodd"
            fillRule="evenodd"
          ></path>
        </svg>
      </div>
    </div>
  );
}

function MintForm(props) {
  return (
    <form
      className="tour-mint-form w-full max-w-lg ml-10"
      onSubmit={props.handleSubmit}
      hidden={!props.showMintForm}
      data-lpignore="true"
    >
      <div className="flex flex-wrap mb-3">
        <div className="px-3 w-full">
          <label
            className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            htmlFor="wallet_address"
          >
            Ethereum, ENS or Email Address
          </label>
          <input
            className="tour-mint-form-address appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
            id="wallet_address"
            type="text"
            placeholder="0x... or jane@ribbon.cool"
            name="wallet_address"
            onChange={props.handleEthValidation}
            autoComplete="off"
          />

          {addressRenderSwitch(props.addressMode)}
        </div>

        <div className="w-full md:w-1/2 px-3 mb-3">
          <label
            className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            htmlFor="award_title"
          >
            Award Title
          </label>
          <input
            className="w-full appearance-none block bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
            id="award_title"
            type="text"
            placeholder="One Year Anniversary"
            name="award_title"
            value={props.nftMetadata.award_title || ""}
            onChange={props.handleChange}
          />
        </div>

        <div className="w-full md:w-1/2 px-3 mb-3">
          <label
            className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            htmlFor="award_title"
          >
            Team
          </label>
          {/* <input
            className="w-full appearance-none block bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
            id="award_title"
            type="text"
            placeholder="One Year Anniversary"
            name="award_title"
            value={props.nftMetadata.award_title || ""}
            onChange={props.handleChange}
          /> */}

          <TeamSelect
            userId={props.nftMetadata.issuer_id}
            handleSelectTeam={props.handleSelectTeam}
          />
        </div>

        <div className="px-3 w-full ">
          <div>
            <label
              className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
              htmlFor="description"
            >
              Description
            </label>
            <textarea
              className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
              id="description"
              type="text"
              placeholder="An example"
              name="description"
              value={props.nftMetadata.description}
              onChange={props.handleChange}
            >
              {" "}
            </textarea>
          </div>
        </div>

        <RenderOptionalFormFields
          nftFormFields={props.nftFormFields}
          nftMetadata={props.nftMetadata}
          handleFieldValueChange={props.handleChange}
          handleFieldNameChange={props.handleFieldNameChange}
          handleRemoveField={props.handleRemoveField}
        />

        <button className="inline-flex items-center w-full md:w-1/2 px-3 md:mb-0">
          <AiFillPlusCircle size={30} onClick={props.handleAddField} />
          <div className="block uppercase text-gray-700 text-xs font-bold ml-2">
            Add Field
          </div>
        </button>
      </div>

      <div className="flex items-center justify-center mb-6">
        <button
          className="tour-mint-button shadow bg-purpler hover:bg-purple-400 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 rounded"
          type="submit"
        >
          Create Award
        </button>
      </div>
    </form>
  );
}

function publicAnimationUrl(logoStatus, userId, animationFilename) {
  if (logoStatus) {
    return `https://ribbon-public-assets.s3.amazonaws.com/${userId}/${animationFilename}`;
  } else {
    return `https://ribbon-public-assets.s3.amazonaws.com/${animationFilename}`;
  }
}

function NftAnimation(props) {
  const [animationUrl, setAnimationUrl] = useState(
    "https://ribbon-public-assets.s3.amazonaws.com/Ribbon_FullRes_LightBlue_1x1.mp4"
  );

  const [isLoading, setIsLoading] = useState(true);

  const logoStatus = true;

  const swapImage = (e) => {
    e.preventDefault();

    switch (e.target.name) {
      case "blue":
        setAnimationUrl(
          publicAnimationUrl(
            logoStatus,
            props.user.id,
            "Ribbon_FullRes_LightBlue_1x1.mp4"
          )
        );
        break;
      case "purple":
        setAnimationUrl(
          publicAnimationUrl(
            logoStatus,
            props.user.id,
            "Ribbon_FullRes_LightPurple_1x1.mp4"
          )
        );
        break;
      case "salmon":
        setAnimationUrl(
          publicAnimationUrl(
            logoStatus,
            props.user.id,
            "Ribbon_FullRes_Salmon_1x1.mp4"
          )
        );
    }
  };

  return (
    <div>
      <div
        className="absolute top-2 right-2 inline-flex shadow-md hover:shadow-lg focus:shadow-lg"
        role="group"
      >
        <button
          type="button"
          name="blue"
          onClick={swapImage}
          className=" rounded-l inline-block px-2.5 py-2.5 bg-bluer text-white font-medium text-xs leading-tight uppercase focus:bg-blue-700 focus:outline-none focus:ring-0 active:bg-blue-800 transition duration-150 ease-in-out"
        ></button>
        <button
          type="button"
          name="purple"
          onClick={swapImage}
          className=" inline-block px-2.5 py-2.5 bg-purpler text-white font-medium text-xs leading-tight uppercase focus:bg-blue-700 focus:outline-none focus:ring-0 active:bg-blue-800 transition duration-150 ease-in-out"
        ></button>
        <button
          type="button"
          name="salmon"
          onClick={swapImage}
          className=" rounded-r inline-block px-2.5 py-2.5 bg-salmonr text-white font-medium text-xs leading-tight uppercase focus:bg-blue-700 focus:outline-none focus:ring-0 active:bg-blue-800 transition duration-150 ease-in-out"
        ></button>
      </div>

      <div key={animationUrl}>
        <video
          autoPlay
          muted
          loop
          playsInline
          onLoadedData={() => setIsLoading(false)}
          poster="https://ribbon-public-assets.s3.amazonaws.com/temp-image.png"
        >
          <source src={animationUrl} type="video/mp4" />
        </video>
      </div>
    </div>
  );
}

function NftPreview(props) {
  return (
    <div>
      <NftAnimation user={props.user} />

      <div className="px-6 py-4">
        <div className="font-bold text-xl mb-2">
          {props.nftMetadata.award_title}
        </div>
        <p className="text-gray-700 text-base">
          {props.nftMetadata.description}
        </p>
      </div>
      <div className="px-6 pt-4 pb-2">
        {Object.keys(props.formFields).map((key) => {
          const metadataKey = props.formFields[key].metadata_key;
          if (props.nftMetadata[metadataKey]) {
            return (
              <span
                key={key}
                className={`inline-block ${props.formFields[key].color_class} rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2`}
              >
                {props.nftMetadata[metadataKey]}
              </span>
            );
          }
        })}
      </div>
    </div>
  );
}

function Mint() {
  const { user } = useAuth();

  // in the near future we will retrieve this from supabase / team profile
  // const [nftFormFields, setNftFormFields] = useState({
  //   0: {
  //     metadata_key: "points",
  //     display_name: "Points",
  //     placeholder: "10",
  //     value: "10",
  //     required: false,
  //     type: "text",
  //     color_class: "bg-blue-300",
  //   }
  // });

  const [nftFormFields, setNftFormFields] = useState({});
  // This acts as the minimal set of NFT metadata
  // In the future we should specify this at the API level
  const [nftMetadata, setNftMetadata] = useState({
    award_id: null,
    issuer_id: null,
    team_id: null,
    wallet_address: "",
    award_title: "One Year Anniversary",
    description: "Congratulations on one year with us!",
    image:
      "https://ribbon-public-assets.s3.amazonaws.com/Ribbon_FullRes_LightBlue_1x1.mp4",
  });

  const [mintSectionStatus, setMintSectionStatus] = useState({
    showMintForm: true,
    showShareSheet: false,
    showLoadingModal: false,
    showEthWarning: false,
    addressMode: "empty",
    polygonscanUrl: "",
    openseaUrl: "",
    directMint: true,
  });

  useEffect(() => {
    if (user.id) {
      console.log("user", user);
      setNftMetadata((nftMetadata) => ({ ...nftMetadata, issuer_id: user.id }));
    }

    if (nftFormFields) {
      Object.keys(nftFormFields).forEach((key) => {
        setNftMetadata((nftMetadata) => ({
          ...nftMetadata,
          [nftFormFields.metadata_key]: nftFormFields[key].value,
          issuer_id: user.id,
        }));
      });
    }

    console.log(nftFormFields);
    console.log(nftMetadata);
  }, [user, nftFormFields]);

  const handleChange = (e) => {
    const target = e.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    setNftMetadata({
      ...nftMetadata,
      [name]: value,
    });
  };

  const handleFieldNameChange = (e) => {
    const target = e.target;

    const oldMetadataKey = nftFormFields[target.name].metadata_key;
    const newMetadataKey = e.target.value.toLowerCase().replace(/ /g, "_");

    const cleanedNftMetadata = { ...nftMetadata };
    delete cleanedNftMetadata[oldMetadataKey];

    setNftMetadata({
      ...cleanedNftMetadata,
      [newMetadataKey]: nftMetadata[oldMetadataKey],
    });

    setNftFormFields({
      ...nftFormFields,
      [target.name]: {
        ...nftFormFields[target.name],
        display_name: target.value,
        metadata_key: newMetadataKey,
      },
    });
  };

  const handleAddField = (e) => {
    e.preventDefault();
    const key = Object.keys(nftFormFields).length;

    setNftFormFields({
      ...nftFormFields,
      [key]: {
        metadata_key: "example_key" + key,
        display_name: "Example Field",
        placeholder: "Placeholder",
        value: "",
        required: false,
        type: "text",
        color_class: randColorClass(),
      },
    });
  };

  const handleSelectTeam = (team_id) => {
    setNftMetadata((nftMetadata) => ({ ...nftMetadata, team_id: team_id }));
    console.log("selecting team", team_id);
  };

  const handleRemoveField = (key) => {
    const updatedNftFormFields = { ...nftFormFields };
    delete updatedNftFormFields[key];
    setNftFormFields(updatedNftFormFields);

    console.log(key);
  };

  const handleEthValidation = (e) => {
    handleChange(e);
    if (ethereum_address.isAddress(e.target.value)) {
      setMintSectionStatus({ ...mintSectionStatus, addressMode: "eth" });
    } else if (e.target.value.endsWith(".eth")) {
      setMintSectionStatus({ ...mintSectionStatus, addressMode: "ens" });
    } else if (validateEmail(e.target.value)) {
      setMintSectionStatus({ ...mintSectionStatus, addressMode: "email" });
    } else if (e.target.value.length == 0) {
      setMintSectionStatus({ ...mintSectionStatus, addressMode: "empty" });
    } else {
      setMintSectionStatus({ ...mintSectionStatus, addressMode: null });
      console.log("hit");
    }
    console.log(e);
  };

  const storeMetadataDB = async (metadata, addressMode) => {
    // should this list be stored elsewhere?
    const requiredMetadataKeys = [
      "issuer_id",
      "team_id",
      "award_title",
      "description",
      "image",
      "wallet_address",
      "award_id",
    ];

    let customMetadata = {};
    Object.keys(metadata).forEach((key) => {
      if (!requiredMetadataKeys.includes(key)) {
        customMetadata[key] = metadata[key];
      }
    });

    // Resolve ENS address before storing in supabase
    let eth_address = null;
    if (addressMode == "eth") {
      eth_address = metadata.wallet_address;
    } else if (addressMode == "ens") {
      eth_address = await getENS(metadata.wallet_address);
    }

    let { data: awardData, error: awardError } = await supabase
      .from("awards")
      .insert([
        {
          issuer_id: metadata.issuer_id,
          team_id: metadata.team_id,
          award_title: metadata.award_title,
          description: metadata.description,
          email: addressMode == "email" ? metadata.wallet_address : null,
          eth_address: eth_address,
          minted: false,
          emailed: false,
          media: metadata.image,
          custom_metadata: customMetadata,
        },
      ])
      .select()
      .single();

    if (awardError) {
      console.log("Error inserting award", awardError);
    } else {
      console.log("award data", awardData);
      return awardData.id;
    }
  };

  const sendEmail = async (metadata, awardId) => {
    console.log("metadata email", metadata);
    let { data: emailData, error: emailError } = await supabase.rpc(
      "send_email_message",
      {
        message: {
          sender: "sender@em1141.ribbon.cool",
          recipient: metadata.wallet_address,
          subject: "You have a Ribbon Award",
          html_body: `
            <img src="https://beta.ribbon.cool/images/ribbon-award.png" />
            <p>Your Ribbon award is waiting for you!</p>
            <p>Here's a <a href="${process.env.REACT_APP_RIBBON_PLATFORM_URL}/award/${awardId}">public link</a> to your award. 
            </br>Create a Ribbon account or login <a href="${process.env.REACT_APP_RIBBON_PLATFORM_URL}">here</a> to manage your awards and verified profile.</p>
            <p>Congratulations,
            </br>the Ribbon team
            </p>
            `,
        },
      }
    );

    if (emailError) {
      if (emailError.message == "error sending message with sendgrid: 202") {
        console.log("Sendgrid email success");
      } else {
        console.log("Error sending email", emailError);
      }
    } else {
      console.log("success email data", emailData);
      return emailData.id;
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // track("Mint");
    // nftMetadata.image = this.nftAnima.state.image;

    setMintSectionStatus({
      ...mintSectionStatus,
      showMintForm: false,
      showLoadingModal: true,
    });

    storeMetadataDB(nftMetadata, mintSectionStatus.addressMode).then(
      (awardId) => {
        console.log("award id", awardId);

        if (mintSectionStatus.addressMode == "email") {
          // send email via supabase->sendgrid
          sendEmail(nftMetadata, awardId);
        }

        // update state for later usage, we also indepnently pass this to the mint function
        setNftMetadata({ ...nftMetadata, award_id: awardId });
        submitForMint(nftMetadata, awardId, mintSectionStatus.addressMode);
      }
    );
  };

  const submitForMint = async (nftMetadata, award_id, addressMode) => {
    let mintData = { ...nftMetadata };
    mintData.award_id = award_id;

    if (addressMode == "ens") {
      let resolvedAddress = await getENS(mintData.wallet_address);
      mintData.wallet_address = resolvedAddress;
      console.log("ENS");
      console.log("resolved address", resolvedAddress);
      console.log("mint data", mintData);
    }

    console.log("NFT data prior to mint: ", mintData);

    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(mintData),
    };

    fetch(
      `${process.env.REACT_APP_MINT_API_ROOT}/api/mintNftPortJSON-v2`,
      requestOptions
    )
      .then((res) => {
        setMintSectionStatus({
          ...mintSectionStatus,
          showShareSheet: true,
          showMintForm: false,
          showLoadingModal: false,
        });

        return res.json();
      })
      .then((data) => {
        console.log("data all", data);
        console.log("data body", data.body);
        if (data.body.mint_type == "direct") {
          setMintSectionStatus({
            ...mintSectionStatus,
            polygonscanUrl: data.body.polygon,
            openseaUrl: data.body.opensea,
            showShareSheet: true,
            showMintForm: false,
            showLoadingModal: false,
          });

          if (data.statusCode == 200) {
            //update award record to show it has been minted
            supabase
              .from("awards")
              .update({ minted: true })
              .eq("id", award_id)
              .then((res) => {
                console.log("award updated", res);
              });
          }
        } else {
          setMintSectionStatus({ ...mintSectionStatus, directMint: false });
        }
      })
      .catch(function (error) {
        console.log("Error minting", error);
      });
  };

  const returnActiveArea = () => {
    if (mintSectionStatus.showMintForm) {
      return (
        <MintForm
          nftFormFields={nftFormFields}
          handleEthValidation={handleEthValidation}
          nftMetadata={nftMetadata}
          handleFieldNameChange={handleFieldNameChange}
          handleSelectTeam={handleSelectTeam}
          handleAddField={handleAddField}
          handleChange={handleChange}
          handleRemoveField={handleRemoveField}
          handleSubmit={handleSubmit}
          showMintForm={mintSectionStatus.showMintForm}
          showEthWarning={mintSectionStatus.showEthWarning}
          addressMode={mintSectionStatus.addressMode}
        />
      );
    } else if (mintSectionStatus.showLoadingModal) {
      return <ImSpinner6 size={40} className="animate-spin" />;
    } else if (mintSectionStatus.showShareSheet) {
      return (
        <div>
          <ShareSheet
            awardId={nftMetadata.award_id}
            polygonscanUrl={mintSectionStatus.polygonscanUrl}
            openseaUrl={mintSectionStatus.openseaUrl}
            directMint={mintSectionStatus.directMint}
          />
          {/* <Confetti
            colors={["#D29F92", "#6086E6", "#A395CA"]}
            tweenDuration={50000}
            numberOfPieces={1200}
            recycle={false}
          /> */}
        </div>
      );
    }
  };

  return (
    <div className="tour-start rounded overflow-hidden shadow-lg flex justify-center items-center h-screen w-full">
      {returnActiveArea()}
      <div className="tour-award-display relative max-w-sm min-h-120 rounded overflow-hidden shadow-lg ml-10 mr-10">
        <NftPreview nftMetadata={nftMetadata} formFields={nftFormFields} />
      </div>
    </div>
  );
}

export default Mint;
